import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSeo } from "../lib/seo";
import Reveal from "../components/Reveal";

const TITLES = { privacy: "Kebijakan Privasi", terms: "Ketentuan Penggunaan" };

export default function InfoPage({ pageKey }) {
  const [page, setPage] = useState(null);
  useSeo({ title: `${TITLES[pageKey]} — Heri Sensei`, description: "Informasi Heri Sensei.", path: pageKey === "privacy" ? "/privasi" : "/ketentuan" });

  useEffect(() => {
    api.get(`/content/${pageKey}`).then((r) => setPage(r.data)).catch(() => setPage({}));
  }, [pageKey]);

  const c = page || {};
  return (
    <div data-testid={`info-page-${pageKey}`} className="max-w-[760px] mx-auto px-4 sm:px-8 py-14 md:py-20">
      <Reveal>
        <h1 className="font-serif text-4xl tracking-tight text-ink">{c.title || TITLES[pageKey]}</h1>
        <div className="reader mt-8" dangerouslySetInnerHTML={{ __html: c.body || "" }} />
        <p className="text-[13px] text-faint mt-10 border-t border-line pt-6">
          Informasi halaman ini akan diperbarui secara berkala.
        </p>
      </Reveal>
    </div>
  );
}
